var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4030",
    x: 2.2002,
    y: 0.5,
    width: 7,
    height: 3,
    rx: 1,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    d: "M3.5 3.5L1 8.5V22C1 22.5523 1.44772 23 2 23H9.5C10.0523 23 10.5 22.5523 10.5 22V8.5L8 3.5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1934 22.8547C15.6364 22.1605 13.9067 22.0539 12.2948 22.8446C12.1137 22.9334 11.8943 22.919 11.7386 22.7908C7.56827 19.3583 7.57765 14.6031 11.3176 12.1175C11.4322 12.0414 11.5755 12.02 11.7089 12.0534C13.9295 12.6094 15.3299 12.5699 17.8268 12.0373C17.9384 12.0135 18.0574 12.0279 18.158 12.0817C21.925 14.0937 21.9408 18.8645 17.7523 22.7703C17.6025 22.91 17.3805 22.9381 17.1934 22.8547Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5H10.5M11.7089 12.0534C13.9295 12.6094 15.3299 12.5699 17.8268 12.0373C17.9384 12.0135 18.0574 12.0279 18.158 12.0817C21.925 14.0937 21.9408 18.8645 17.7523 22.7703C17.6025 22.91 17.3805 22.9381 17.1934 22.8547C15.6364 22.1605 13.9067 22.0539 12.2948 22.8446C12.1137 22.9334 11.8943 22.919 11.7386 22.7908C7.56827 19.3583 7.57765 14.6031 11.3176 12.1175C11.4322 12.0414 11.5755 12.02 11.7089 12.0534Z",
    stroke: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 123",
    d: "M13.1213 9.51493C12.8534 9.44795 12.5819 9.61083 12.5149 9.87873C12.448 10.1466 12.6108 10.4181 12.8787 10.4851L13.1213 9.51493ZM13 10C12.8787 10.4851 12.8785 10.485 12.8783 10.485C12.8782 10.485 12.878 10.4849 12.8779 10.4849C12.8777 10.4848 12.8775 10.4848 12.8773 10.4847C12.8769 10.4846 12.8767 10.4846 12.8766 10.4845C12.8763 10.4845 12.8765 10.4845 12.8771 10.4847C12.8784 10.485 12.8815 10.4858 12.8862 10.4872C12.8955 10.4898 12.9114 10.4945 12.9329 10.5014C12.976 10.5153 13.0409 10.5379 13.1202 10.5709C13.2801 10.6376 13.4914 10.7435 13.7 10.9C14.109 11.2068 14.5 11.6964 14.5 12.5H15.5C15.5 11.3036 14.891 10.5432 14.3 10.1C14.0086 9.88145 13.7199 9.73744 13.5048 9.64784C13.3966 9.60276 13.3052 9.57069 13.2389 9.54938C13.2057 9.5387 13.1787 9.53068 13.1588 9.52504C13.1488 9.52222 13.1406 9.51999 13.1343 9.51831C13.1312 9.51748 13.1285 9.51678 13.1263 9.51622C13.1252 9.51594 13.1243 9.51569 13.1234 9.51547C13.123 9.51537 13.1226 9.51527 13.1223 9.51518C13.1221 9.51513 13.1218 9.51507 13.1217 9.51505C13.1215 9.51499 13.1213 9.51493 13 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 124",
    d: "M1 17H8.5",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryFood);
export default __webpack_public_path__ + "static/media/project-category-food.475081bf.svg";
export { ForwardRef as ReactComponent };